<template>
  <SimpleLoadingChartContainer
    :key="chartKey"
    :chart-options="displayChartOptions"
    :loading="displayLoading"
    loading-text="Loading vessel wind chart data..."
    :elevation="3"
  >
    <template #header>
      <div class="wind-header">
        <span class="relative-wind-title">
          {{ isRelativeWind ? 'Relative Wind' : 'True Wind' }}
        </span>

        <button
          class="wind-toggle-btn"
          @click="toggleWind"
        >
          {{ isRelativeWind ? 'Show True Wind' : 'Show Relative Wind' }}
        </button>
      </div>
    </template>
  </SimpleLoadingChartContainer>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import SimpleLoadingChartContainer from "../../../core/SimpleLoadingChartContainer.vue";

export default {
  name: "VesselWindChart",

  components: {
    SimpleLoadingChartContainer,
  },

  computed: {
    /* GLOBAL MODE */
    ...mapState("windGlobalModule", {
      isRelativeWind: function (state) {
        return state.isRelativeWind;
      },
    }),

    /* TRUE WIND */
    ...mapGetters("vesselInformation/voyageWindDataModule", {
      trueWindChartOptions: "chartOptions",
    }),
    ...mapState("vesselInformation/voyageWindDataModule", {
      trueWindLoading: function (state) {
        return state.fetchLoading;
      },
    }),

    /* RELATIVE WIND */
    ...mapGetters("vesselInformation/voyageRelativeWindDataModule", {
      relativeWindChartOptions: "chartOptions",
    }),
    ...mapState("vesselInformation/voyageRelativeWindDataModule", {
      relativeWindLoading: function (state) {
        return state.fetchLoading;
      },
      relativeWindRaw: function (state) {
        return state.voyageRelativeWindData;
      },
    }),

    selectedVessel() {
      return this.$store.state.main.selectedVessel;
    },
    emptyChart() {
      return {
        series: [],
        title: { text: null },
        credits: { enabled: false }
      };
    },

    vesselName() {
      return this.selectedVessel
        ? this.selectedVessel.vessel
        : null;
    },

    selectedLeg() {
      return this.$store.state.vesselInformation.selectedLeg;
    },

    displayChartOptions() {
      if (this.isRelativeWind) {
        return this.relativeWindChartOptions || this.emptyChart;
      } else {
        return this.trueWindChartOptions || this.emptyChart;
      }
    },

    displayLoading() {
      return this.isRelativeWind
        ? this.relativeWindLoading
        : this.trueWindLoading;
    },
    chartKey() {
      return (
        (this.isRelativeWind ? "rel" : "true") +
    "-" +
    (this.vesselName || "") +
    "-" +
    (this.selectedLeg ? this.selectedLeg.startDate : "")
      );
    },

  },

  watch: {
    /* Toggle */
    isRelativeWind(newVal) {
      if (!newVal) return;
      this.fetchIfNeeded();
    },

    /* Vessel change */
    vesselName(newVal, oldVal) {
      if (newVal !== oldVal && this.isRelativeWind) {
        this.fetchIfNeeded(true);
      }
    },

    /* Leg change */
    selectedLeg(newVal, oldVal) {
      if (newVal !== oldVal && this.isRelativeWind) {
        this.fetchIfNeeded(true);
      }
    },
  },

  methods: {
    ...mapActions("windGlobalModule", [
      "toggleWindMode",
    ]),

    ...mapActions("vesselInformation/voyageRelativeWindDataModule", [
      "fetchVoyageRelativeWindData",
    ]),

    toggleWind() {
      this.toggleWindMode();
    },

    fetchIfNeeded(force = false) {
      if (!this.vesselName || !this.selectedLeg) return;

      if (!force && this.relativeWindRaw) {
        return; // already loaded
      }

      const startDate = this.selectedLeg.startDate
        .substring(0, 19)
        .replace("T", " ");

      const stopDate = this.selectedLeg.stopDate
        .substring(0, 19)
        .replace("T", " ");

      this.fetchVoyageRelativeWindData({
        name: this.vesselName,
        startDate,
        stopDate,
      });
    },
  },
};
</script>

<style scoped>
.wind-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.relative-wind-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text);
}

.wind-toggle-btn {
  border: 3px solid var(--color-border);
  background: transparent;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  color: rgb(49, 159, 192);
  transition: all 0.2s ease;
}

.wind-toggle-btn:hover {
  background: rgba(0, 0, 0, 0.08);
}
</style>
